import PropTypes from "prop-types";
import React from "react";
import {
  Button,
  CardTitle,
  ModalBody,
  ModalFooter,
  ModalHeader,
  Table,
} from "reactstrap";
import PopupComponent from "src/Components/Popup/popup";
import __ from "src/utils/Translations";
import displayList from "./displayList";

export default function MessageDataPopup({
  messageData,
  messageParameters,
  close,
}) {
  return (
    <>
      <PopupComponent
        id="messageDataPopup"
        isOpen
        toggle={close}
        unmountOnClose
        size="xxl"
      >
        <ModalHeader toggle={close}>{__("Szczegóły")}</ModalHeader>
        <ModalBody>
          <Table className="mt-2 word-break">
            <tbody>
              <td key="after" style={{ maxWidth: "350px" }}>
                {messageData && (
                  <pre style={{ overflowWrap: "break-word" }}>
                    {JSON.stringify(messageData, null, 4)}
                  </pre>
                )}
              </td>
            </tbody>
          </Table>
          {messageParameters?.payload &&
            displayList(messageParameters.payload, "Payload")}
          {messageParameters?.response &&
            displayList(messageParameters.response, "Response")}
        </ModalBody>
        <ModalFooter>
          <Button color="primary" onClick={close}>
            Zamknij
          </Button>
        </ModalFooter>
      </PopupComponent>
    </>
  );
}

MessageDataPopup.propTypes = {
  close: PropTypes.func.isRequired,
  messageData: PropTypes.string.isRequired,
  messageParameters: {
    payload: PropTypes.shape({}),
    response: PropTypes.shape({}),
  },
};

MessageDataPopup.defaultProps = {
  messageParameters: null,
};
